import React from "react";

function FundingnetworksIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g clipPath="url(#clip0_1097_6528)">
        <path
          fill="#fff"
          d="M13.21 4.26c.59 0 1.13-.23 1.54-.65.39-.41.61-.95.59-1.52a2.131 2.131 0 00-2.13-2.1c-.59 0-1.13.23-1.54.65-.67.69-.78 1.74-.31 2.55L8.92 5.7c-.38-.23-.81-.35-1.26-.35-.51 0-1.01.16-1.43.46l-1.59-1.4A1.692 1.692 0 003.07 2.1h-.11c-.45.03-.86.24-1.16.58-.3.34-.45.78-.42 1.23a1.685 1.685 0 002.5 1.37l1.59 1.4c-.19.36-.29.75-.29 1.16 0 .48.13.94.39 1.33l-2.44 2.51a2.131 2.131 0 00-2.55.39c-.4.41-.59.96-.58 1.53 0 .57.24 1.1.65 1.49.4.38.92.6 1.52.6.57-.01 1.1-.24 1.49-.65.67-.69.78-1.74.31-2.55l2.44-2.51c.21.13.45.22.69.28v1.42c-.96.26-1.63 1.12-1.63 2.13 0 1.21.99 2.2 2.2 2.2 1.21 0 2.2-.99 2.2-2.2 0-1.01-.67-1.87-1.63-2.13v-1.42c.49-.12.92-.37 1.26-.75l1.86 1.02c-.11.7.22 1.4.86 1.75a1.68 1.68 0 002.29-.67c.22-.4.27-.85.14-1.29a1.698 1.698 0 00-1.62-1.22c-.41 0-.81.15-1.12.42L10.06 8.5c.06-.21.09-.43.09-.66 0-.48-.13-.94-.39-1.33L12.2 4c.31.17.66.26 1.01.26zM2.13 12.58c.25 0 .5.1.68.28.19.18.3.43.3.69 0 .26-.09.51-.27.7-.18.19-.43.3-.71.3-.25 0-.5-.1-.68-.28a.954.954 0 01-.3-.69c0-.26.09-.51.27-.7.18-.19.43-.3.69-.3h.02zm5.54 2.28a1.05 1.05 0 110-2.1 1.05 1.05 0 010 2.1zm0-5.68c-.73 0-1.33-.6-1.33-1.33 0-.73.6-1.33 1.33-1.33.73 0 1.33.6 1.33 1.33 0 .73-.6 1.33-1.33 1.33zm6.52-7.06c0 .26-.09.51-.27.7a.987.987 0 01-1.39.03.99.99 0 01-.03-1.39.987.987 0 011.39-.03c.19.18.3.43.3.69zM3.07 3.27c.13 0 .26.05.36.13a.541.541 0 01-.36.95c-.13 0-.26-.05-.36-.13a.545.545 0 01-.18-.37c0-.14.04-.28.13-.39.1-.11.23-.17.38-.18h.03v-.01zm10.48 7.37c.04.14.02.29-.04.41-.1.17-.28.28-.48.28-.09 0-.18-.02-.26-.07a.54.54 0 01-.21-.74c.1-.17.28-.28.48-.28.09 0 .18.02.26.07.13.07.22.18.26.32l-.01.01z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1097_6528">
          <path fill="#fff" d="M0 0H15.34V16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default React.memo(FundingnetworksIcon);
